<style lang="less">
    @import './net-error.less';
</style>

<template>
    <div class="error404">
        <div class="error404-body-con">
            <Card>
                <div class="error404-body-con-title">Network Error</div>
                <p class="error404-body-con-message">{{$t('l.remark180')}}</p>
                <p class="error404-body-con-message">ERR_CONNECTION_REFUSED</p>
                <div class="error404-btn-con">
                    <a style="color: #000" href="https://www.diantiyun.com/">
                        <span class="forget" >{{$t('l.remark175')}}</span>
                    </a>
                    <Button @click="diagnoseErrors" size="large" style="width: 200px;margin-left: 40px;" type="primary">{{$t('l.remark181')}}</Button>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'net-error',
    methods: {
        backPage () {
            this.$router.go(-1);
        },
        goHome () {
            location.href = '/';
        },
        diagnoseErrors() {
            if (window.errorPageController)
                errorPageController.diagnoseErrorsButtonClick();
        }
    }
};
</script>
